/* eslint-disable @next/next/no-html-link-for-pages */
import React from 'react'
import { useEffect, useRef } from 'react';
import { logout } from 'SRC/modules/users/Auth/actions'
import { connect } from 'react-redux'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'
import setLanguage from 'next-translate/setLanguage'
import { setShowNavigation } from 'SRC/modules/vehicleParts/list/actions'
import { getShowNavigation } from 'SRC/modules/vehicleParts/list/selectors'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import translations from '../../../../../../../public/data/translations.json'

import SidebarButton from '../SidebarButton/SidebarButton';
import Logo from '../SidebarButton/icons/Logo'
import styles from '../SidebarButton/Navbar.module.css';
import Strelica from '../SidebarButton/icons/Strelica';
import BiznisAdresarDugme from "../BiznisAdresarDugme/BiznisAdresarDugme";
import LangButton from '../LangButton/LangButton';

const profilePageSlugs = {
	'/profil': {
		en: '/profile',
		ua: '/profil',
		me: '/profil',
		al: '/profili',
		de: '/profil',
		ru: '/profil',
		tr: '/profil',
	}
}

function SideMenu({ logout, showNavigation, setShowNavigation, isAuthorized }) {
	const [showHoldCircle, setShowHoldCircle] = React.useState(false);
	const [isBusinessUsersExpanded, setIsBusinessUsersExpanded] = React.useState(false);
	const expandedBusinessUsers = () => {
		setIsBusinessUsersExpanded(!isBusinessUsersExpanded);
	};
	const { lang, t } = useTranslation('common');

	const locale = lang?.toUpperCase() || 'ME';

	useEffect(() => {
		setLanguage(lang)
	}, [])

	const [isLangExpanded, setIsLangExpanded] = React.useState(false);

	const sadrzajMainRef = useRef(null);

	const expandedLang = () => {
		setIsLangExpanded(!isLangExpanded);

		setTimeout(() => {
			sadrzajMainRef.current?.scrollTo({
				top: sadrzajMainRef.current?.scrollHeight,
				behavior: "smooth"
			});
		}, 200);
	};

	const isDragging = useRef(false);
	const wasDragging = useRef(false);

	const handleMouseDown = (e) => {
		if (showNavigation) return;
		isDragging.current = true;
		wasDragging.current = false;
	};

	useEffect(() => {
		if (showNavigation) document.body.style.overflow = 'hidden';
		else document.body.style.overflow = 'auto';
	}, [showNavigation]);

	return (
		<div className={styles.navbar}>
			<div
				className={`${styles.overlay} ${showNavigation ? styles.overlayVisible : styles.overlayHidden}`}
				onClick={() => setShowNavigation(false)}
			/>
			<aside style={{
				borderTopLeftRadius: '20px !important',
				borderBottomLeftRadius: '20px !important'
			}} className={`${styles.sidebar} ${showNavigation ? styles.sidebarOpen : styles.sidebarClosed}`}>
				<div className={styles.sadrzajHeader}>
					<button onClick={() => setShowNavigation(false)} className={styles.sadrzajStrelicaDugme}>
						<Strelica />
					</button>
					<Logo />
				</div>
				<div className={styles.sadrzajMain} ref={sadrzajMainRef}>
					<Link href={'/'} as={`/`}>
						<a style={{ display: 'block', height: '50px' }} onClick={() => setShowNavigation(false)}>
							<SidebarButton text={t("Svi oglasi")} icon="home" />
						</a>
					</Link>

					<Link href={'/categories'} as={`${translations.kategorije[locale]}`}>
						<a style={{ display: 'block', height: '50px' }} nClick={() => setShowNavigation(false)}>
							<SidebarButton text={t('Kategorije')} icon="kategorije" />
						</a>
					</Link>

					<Link
						as={`/dodaj`}
						href={{ pathname: '/addAd' }}
					>
						<a style={{ display: 'block', height: '50px' }}
							onClick={() => setShowNavigation(false)}>
							<SidebarButton text={t('Dodaj oglas')} icon="dodajOglas" />
						</a>
					</Link>

					<div className={styles.linija}></div>

					<BiznisAdresarDugme
						setIsSidebarOpen={setShowNavigation}
						isExpanded={isBusinessUsersExpanded}
						onToggle={expandedBusinessUsers}
					/>

					<div className={styles.linija}></div>

					<Link
						as={`/profil/oglasi`}
						href={{ pathname: '/profile', query: { page: 'oglasi' } }}
					>
						<a style={{ display: 'block', height: '50px' }}
							onClick={() => setShowNavigation(false)}>
							<SidebarButton text={t("Moji oglasi")} icon="mojiOglasi" />
						</a>
					</Link>

					<Link
						as={`/profil/notifikacije`}
						href={{ pathname: '/profile', query: { page: 'notifikacije' } }}
					>
						<a style={{ display: 'block', height: '50px' }}
							onClick={() => setShowNavigation(false)}>
							<SidebarButton text={t("Poruke")} icon="poruke" />
						</a>
					</Link>

					<Link
						as={`/profil/sacuvani-oglasi`}
						href={{ pathname: '/profile', query: { page: 'sacuvani-oglasi' } }}
					>
						<a style={{ display: 'block', height: '50px' }}
							onClick={() => setShowNavigation(false)}>
							<SidebarButton text={t("Sačuvani oglasi")} icon="sacuvaniOglasi" />
						</a>
					</Link>

					<Link
						as={`/profil/sacuvani-profili`}
						href={{ pathname: '/profile', query: { page: 'sacuvani-profili' } }}
					>
						<a style={{ display: 'block', height: '50px' }}
							onClick={() => setShowNavigation(false)}>
							<SidebarButton text={t("Sačuvani profili")} icon="sacuvaniProfili" />
						</a>
					</Link>

					<Link
						as={`/profil/sacuvane-pretrage`}
						href={{ pathname: '/profile', query: { page: 'sacuvane-pretrage' } }}
					>
						<a style={{ display: 'block', height: '50px' }}
							onClick={() => setShowNavigation(false)}>
							<SidebarButton text={t("Sačuvane pretrage")} icon="sacuvanePretrage" />
						</a>
					</Link>

					<a
						href={`${lang !== 'me' ? `/${lang}` : ''}/marketing`}
						style={{ display: "block", height: "50px" }}
					>
						<SidebarButton text="Marketing" icon="marketing" />
					</a>

					<Link
						as={`/profil`}
						href={{ pathname: '/profile' }}
					>
						<a
							style={{ display: 'block', height: '50px' }}
							href={`${lang !== 'me' ? `/${lang}` : ''}/${profilePageSlugs['/profil'][lang] || 'profil'}`}
						>
							<SidebarButton text={t("Moj profil")} icon="mojProfil" />
						</a>
					</Link>

					{isAuthorized ? (
						<a
							style={{ display: 'block', height: '50px' }}
							href='javascript:void(0)' onClick={() => { logout && logout(); setShowNavigation(false); }}
						>
							<SidebarButton text={t("Izloguj se")} icon="logout" />
						</a>
					) : null}

					<div className={styles.linijafooter}></div>
					<div className={styles.langButtonDiv}>
						<LangButton
							isExpanded={isLangExpanded}
							onToggle={expandedLang} />
					</div>
				</div>

				<button
					onMouseDown={handleMouseDown}
					onClick={() => {
						if (!wasDragging.current) {
							setShowNavigation(!showNavigation);
						}
					}}
					className={`${styles.navDugme} ${showNavigation ? styles.open : styles.closed}`}
					style={{
						position: 'absolute',
						left: '-20px',
						top: `50%`,
						transform: 'translateY(-50%)',
						cursor: 'grab',
						zIndex: 1000,
						opacity: showNavigation ? 1 : 0.9,
						transition: "opacity 0.3s ease",
						border: "none"
					}}
				>
					<svg
						className={styles.navBarStrelica}
						width="15"
						height="25"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M4 2 L12 8 L4 14"
							stroke="white"
							strokeWidth="3"
							fill="none"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
					<svg
						className={styles.dugmeHoldKrug}
						xmlns="http://www.w3.org/2000/svg"
						width="35"
						height="35"
						viewBox="0 0 100 100"
						style={{
							opacity: showHoldCircle ? 1 : 0,
							visibility: showHoldCircle ? 'visible' : 'hidden',
							transition: 'opacity 0.3s ease, visibility 0.3s ease',
							pointerEvents: 'none',
						}}
					>
						<circle cx="50" cy="50" r="48" fill="#3b8eea" />
						<g fill="#fff">
							<path d="M46 38 L54 38 L54 22 L60 22 L50 10 L40 22 L46 22 Z" />
							<path d="M46 62 L54 62 L54 78 L60 78 L50 90 L40 78 L46 78 Z" />
							<path d="M38 46 L38 54 L22 54 L22 60 L10 50 L22 40 L22 46 Z" />
							<path d="M62 46 L62 54 L78 54 L78 60 L90 50 L78 40 L78 46 Z" />
						</g>
					</svg>
				</button>
			</aside >
		</div>
	);
}

const mapStateToProps = (state) => ({
	showNavigation: getShowNavigation(state),
	isAuthorized: getIsAuthorized(state),
})

export default connect(mapStateToProps, { logout, setShowNavigation })(SideMenu);
